import React from "react";
import { Container, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "./404.css"; // Import CSS

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <Container className="text-center">
        <h1>404</h1>
        <h2>Oops! Halaman tidak ditemukan.</h2>
        <p>Halaman yang Anda cari mungkin telah dipindahkan atau tidak tersedia.</p>
        <Button color="dark" onClick={() => navigate("/")}>Kembali ke Beranda</Button>
      </Container>
    </div>
  );
};

export default NotFound;
